__turbopack_context__.v({
  "className": "inter_3cb69f4c-module__6CIMeq__className",
});
